import type { TrackingConsentLocale } from './types';

const locale: TrackingConsentLocale = {
  copy: {
    title: 'Sütiket használunk',
    description:
      'Sütiket és hasonló technológiákat használunk az élmény biztosításához. A szigorúan szükséges sütik mindig aktívak.',
    allow_label: 'Összes süti elfogadása',
    reject_label: 'Csak a szigorúan szükségesek',
    settings_label: 'Sütibeállítások',
    policy_link_label: 'Adatvédelmi és sütiszabályzat',
    categories_label: 'Kategóriák',
    always_on_label: 'Mindig aktív',
    required_label: 'Kötelező',
    save_preferences_label: 'Beállítások mentése',
    close_label: 'Bezárás',
    allow_all_optional_categories_label: 'Minden opcionális kategória engedélyezése',
    save_error: 'Nem sikerült menteni az adatvédelmi beállítását. Próbálja újra.'
  },
  categories: {
    strictly_necessary: {
      name: 'Szigorúan szükséges',
      purpose: 'Az élmény biztosításához szükségesek, és nem kapcsolhatók ki.'
    },
    analytics: {
      name: 'Analitika',
      purpose: 'Méri, hogyan használják a látogatók ezt az élményt a teljesítmény javítása érdekében.'
    },
    marketing: { name: 'Marketing', purpose: 'A szervező által választott hirdetést és marketinget támogatja.' }
  }
};

export default locale;
